import { get, concat } from 'lodash';

import * as actions from '../actions/AdminPanel';

import {
    //SEARCH_RESULT_ITEMS_ORDERING,
    SEARCH_RESULT_ITEMS_PER_PAGE,
    USERS_RESULT_ITEMS_PER_PAGE,
    //SEARCH_RESULT_LANGUAGES,
} from '../utils/constants';
import { getProblemTypesData } from '../utils/responseProcessing';

const initialState = {
    isError: false,
    isFetching: false,
    isErrorForbidden: false,
    filtered: {
        filterParams: {
            type: -1,
        },
        isError: false,
        isDisabled: false,
        isFetchedAll: false,
        isFetching: false,

        draft: 0,
        review: 0,
        rejected: 0,
        published: 0,

        offset: 0,
        count: 0, 
        items: [], 
    },
    data: {
        isError: false,
        isFetching: false,
        isFetchedAll: false,

        count: 0,
        offset: 0,
        page: 1,
        users: [],
    }, // for get and show user data
    comments: {
        isError: true,
        isFetching: false,
        isFetchedAll: false,

        count: 0,
        offset: 0,
        page: 1,
        items: [],
    },
    user: {},
    tickets: {
        filterParams: {
            type: -1,
        },
        offset: 0,
        page: 1,
        isFetchedAll: false,
        
        reviewed: 0,
        answered: 0,
        count: 0,

        items: [],
    },
    ticketView: {
        filterParams: {
            type: -1,
        },
        modData: [],
        ticketId: 0,
        ownerId: null,
        isClose: false,
        ownerName: null,
        problemTypes: [],
        createdAt: null,
        count: 0,

        msg: []
    },
}

export const adminPanel = (state = initialState, action) => {
    const payload = get(action, 'payload')
    switch (action.type) {
        case actions.START_FETCHING_ADMIN_PANEL:
            return {
                ...state,
                isError: false,
                isErrorForbidden: false,
                isFetching: true,
                filtered: {
                    ...state.filtered,
                    isError: false,
                    isFetching: true,
                },
            }
        case actions.SET_ERROR_FETCHING_ADMIN_PANEL:
            return {
                ...state,
                isFetching: false,
                isError: get(payload, 'errorData.status') !== 403,
                isErrorForbidden: get(payload, 'errorData.status') === 403,
                filtered: {
                    ...state.filtered,
                    isError: true,
                },
            }
        case actions.STOP_FETCHING_ADMIN_PANEL:
            return {
                ...state,
                isFetching: false,
                filtered: {
                    ...state.filtered,
                    isFetching: false,
                },
            }
        case actions.INCREMENT_GETTING_OFFSET:
            return {
                ...state,
                filtered: {
                    ...state.filtered,
                    offset: state.filtered.isFetchedAll ?
                        state.filtered.offset :
                        state.filtered.offset + SEARCH_RESULT_ITEMS_PER_PAGE,
                },
            }
        case actions.CHANGE_ADMIN_RESULT_ITEMS_ORDERING:
            return {
                ...state,
                filtered: {
                    draft: 0,
                    review: 0,
                    published: 0,
                    rejected: 0,

                    filterParams: {
                        ...state.filtered.filterParams,
                    },

                    isError: false,
                    isFetchedAll: false,
                    isFetching: false,
                    count: 0,
                    items: [],
                    offset: 0,
                },
            }
        case actions.UPDATE_ITEMS_ADMIN_PANEL:
            return {
                ...state,
                //filtered: payload.filtered,
                filtered: {
                    ...state.filtered,
                    filterParams: {
                        ...state.filtered.filterParams,
                        ...action.payload.filterParams,
                    },
                    isError: false,
                    isFetchedAll: (
                        state.filtered.offset + SEARCH_RESULT_ITEMS_PER_PAGE >= payload.count
                    ),

                    draft: payload.draft,
                    review: payload.review,
                    rejected: payload.rejected,
                    published: payload.published, 

                    items: state.filtered.offset ?
                        concat(state.filtered.items, payload.items) :
                        payload.items,
                    count: payload.count,
                },
            }
        case actions.UPDATE_ITEMS_USERS_PANEL:
            return {
                ...state,
                data: {
                    ...state.data,
                    isError: false,
                    isFetching: false,
                    /*isFetchedAll: (
                        state.data.count > 0 ? state.data.offset + USERS_RESULT_ITEMS_PER_PAGE >= payload.count : false
                    ),*/
                    isFetchedAll: false,

                    count: payload.count,
                    users: payload.users,
                    /*users: state.data.offset ?
                        concat(state.data.users, payload.users) :
                        payload.users,*/
                },
            }
        case actions.INCREMENT_USERS_OFFSET:
            return {
                ...state,
                data: {
                    ...state.data,
                    //isFetchedAll: state.data.page === (state.data.count / 20) ? true : false,
                    offset: state.data.isFetchedAll ?
                        state.data.offset :
                        state.data.page * USERS_RESULT_ITEMS_PER_PAGE - USERS_RESULT_ITEMS_PER_PAGE, //state.data.offset + USERS_RESULT_ITEMS_PER_PAGE,
                },
            }
        case actions.NONINCREMENT_USERS_OFFSET:
            return {
                ...state,
                data: {
                    ...state.data,
                    //isFetchedAll: state.data.page === (state.data.count / 20) ? true : false,
                    offset: state.data.page * USERS_RESULT_ITEMS_PER_PAGE - USERS_RESULT_ITEMS_PER_PAGE, //state.data.offset - USERS_RESULT_ITEMS_PER_PAGE,
                },
            }
        case actions.RESET_USERS_OFFSET:
            return {
                ...state,
                data: {
                    ...state.data,
                    offset: 0,
                    page: 1,
                },
            }
        case actions.CHANGE_USERS_PAGE:
            return {
                ...state,
                data: {
                    ...state.data,
                    page: payload.page,
                },
            }
        case actions.UPDATE_GET_USER_DATA:
            return {
                ...state,
                user: payload.user,
            }
        case actions.UPDATE_SUPPORT_PANEL:
            return {
                ...state,
                tickets: {
                    ...state.tickets,
                    filterParams: payload.filterParams,
                    //isError: false,
                    isFetchedAll: (
                        state.tickets.offset + SEARCH_RESULT_ITEMS_PER_PAGE >= payload.count
                    ),

                    reviewed: payload.reviewed,
                    answered: payload.answered,
                    offset: payload.offset, 

                    items: payload.items,/*state.tickets.offset ?
                        concat(state.tickets.items, payload.items) :
                        payload.items,*/
                    count: payload.count,
                },
            }
        case actions.CHANGE_SUPPORT_PAGE: 
            return {
                ...state,
                tickets: {
                    ...state.tickets,
                    page: payload.page,
                }
            }
        case actions.START_FETCHING_MESSAGES_SUPPORT_PANEL:
            return {
                ...state,
                ticketView: {
                    ...state.ticketView,
                    isError: false,
                    isFetching: true,
                },
            }
        case actions.SET_ERROR_MESSAGES_SUPPORT_PANEL:
            return {
                ...state,
                ticketView: {
                    ...state.ticketView,
                    isError: true,
                    isFetching: false,
                },
            }
        case actions.STOP_FETCHING_MESSAGES_SUPPORT_PANEL:
            return {
                ...state,
                ticketView: {
                    ...state.ticketView,
                    isFetching: false,
                },
            }
        case actions.UPDATE_MESSAGES_SUPPORT_PANEL:
            return {
                ...state,
                ticketView: {
                    ...state.ticketView,
                    filterParams: payload.filterParams,
                    //isError: false,
                    //modData: payload.modData,
                    ticketId: payload.ticketId,
                    ownerId: payload.ownerId,
                    isClose: payload.isClose,
                    ownerName: payload.ownerName,
                    createdAt: payload.createdAt,
                    problemTypes: getProblemTypesData(payload.problemTypes), 

                    msg: payload.msg,
                    count: payload.count,
                },
            }
        case actions.UPDATE_MESSAGES_REPORT_PANEL:
            return {
                ...state,
                ticketView: {
                    ...state.ticketView,
                    filterParams: payload.filterParams,
                    //isError: false,
                    modData: payload.modData,
                    ticketId: payload.ticketId,
                    ownerId: payload.ownerId,
                    isClose: payload.isClose,
                    ownerName: payload.ownerName,
                    createdAt: payload.createdAt,
                    problemTypes: getProblemTypesData(payload.problemTypes), 

                    msg: payload.msg,
                    count: payload.count,
                },
            }
        case actions.UPDATE_TICKETS: // DELETE THIS AFTER
            return {
                ...state,
                tickets: payload.tickets,
            }
        case actions.UPDATE_TICKET:
            return {
                ...state,
                ticketView: payload.ticketView,
            }
        case actions.SET_IS_FORBIDDEN:
            return {
                ...state,
                isErrorForbidden: true,
            }
        default:
            return state
    }
}
